import { h } from "@stencil/core";
/* eslint-disable */
export const WarningFlag = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'>
        <g id='Icon/Flag/Warning' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
            <g id='Icon.Part.Triangle.Warning' transform='translate(2.000000, 5.000000)' fill='#E6BE23' fill-rule='nonzero'>
                <polygon id='Shape' points='43.5294118 37 0 37 21.7647059 0' />
            </g>
            <g id='Icon.Part.Exclamation-Copy' transform='translate(22.000000, 18.000000)' fill='#131313'>
                <path
                    d='M0,0 L1,14 L2.95666504,14 L4,0 L0,0 Z M2,16 C3.104,16 4,16.8946667 4,18 C4,19.104 3.104,20 2,20 C0.896,20 0,19.104 0,18 C0,16.8946667 0.896,16 2,16 Z'
                    id='Shape'
                />
            </g>
        </g>
    </svg>
);
